import { mapActions, mapGetters, mapState } from "vuex";
import { ReadMoreDirective } from "@/utils/directives";
import { debounce } from "@/utils/functions";


export default {
  name: "Table-parts",
  data() {
    return {
      grouped_by: 'manufacturer',
      showSelected: false,
      search: "",
      perPage: 3,
      currentPage: 1,
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin,
      group_list: state => state.parts.group_list,
      totalCount: state => state.parts.pagination.totalCount,
      totalPages: state => state.parts.pagination.totalPages,
      groups: state => state.parts.groups,
      partListBasket: state => state.parts.partListBasket
    }),
    ...mapGetters({
      basicCatalogRequest: 'parts/basicCatalogRequest'
    }),
    headers() {
      return [
        {
          text: this.$i18n.tc("TableResults.Headers.Select"),
          value: "select",
          align: "center",
          sortable: false,
          width: "100px",
          custom_property: '--header-seleccionar-width'
        },
        {
          text: "",
          value: "",
          align: "center",
          sortable: false,
          width: "150px",
          custom_property: '--header-thumbnail-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Description"),
          align: "left",
          sortable: false,
          custom_property: '--header-description-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Mfg"),
          align: "center",
          sortable: false,
          custom_property: '--header-mfg-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Part"),
          align: "center",
          sortable: false,
          custom_property: '--header-part-number-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Yrs"),
          align: "center",
          sortable: false,
          custom_property: '--header-years-width'
        },
        {
          text: this.$isDesktopDevice ? this.$i18n.tc("TableResults.Headers.QtyVehicle") : "CANT. POR VEHICULO",
          sortable: false,
          align: "center",
          width: '150px',
          custom_property: '--header-quantity-width'
        }
      ]
    },
    selected_parts() {
      let selected = [{
        name: 'Selected Parts',
        parts: []
      }];

      this.groups.forEach(group => group.parts.forEach(part => part.selected && selected[0].parts.push(part)));

      return selected;
    },
  },
  directives: {
    ReadMore: ReadMoreDirective,
  },
  components: {
    Pagination: () => import("@/components/Table/Pagination.vue")
  },
  methods: {
    ...mapActions({
      INQUIRY: "parts/INQUIRY"
    }),
    switch_group_by() {
      this.grouped_by = this.grouped_by === 'manufacturer' ? 'description' : 'manufacturer';
      this.getPerPageByGroup();
    },
    update_search_string: debounce(function (new_search_string) {
      console.log("Search string updated:", new_search_string);
      this.search = new_search_string;
      console.log("search 2 ", this.search)
    }, 163),
    
    getPerPage(page, select) {
        this.currentPage = page;
        this.INQUIRY({ request: this.basicCatalogRequest, page: this.currentPage, size: select, group_by: this.grouped_by })       
    },
    getPerPageByGroup() {
      this.INQUIRY({ request: this.basicCatalogRequest, page: 1, size: 25, group_by: this.grouped_by })
    },
    getPerPageTotalCount (select) {
      this.INQUIRY({ request: this.basicCatalogRequest, page: 1, size: select, group_by: this.grouped_by })       

    }
  }
};